import React from 'react'
import CompanyInformationSup from './CompanyInformationSup/CompanyInformationSup'
import NdaSup from './NdaSup/NdaSup';

import { Card, Grid, Step, StepLabel, Stepper } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import CobcSup from './CobcSup/CobcSup';
import BankAccountSup from './BankAccount/BankAccountSup';
import DueDiligenceSup from './DueDiligenceSup/DueDiligenceSup';
import PrequalificationSup from './PrequalificationSup/PrequalificationSup';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ButtonList from '../../components/Button/ButtonList';
import { useGetCurrentUserInfoQuery } from '../../store/api/userApi';
import { setStep } from '../../store/slice/buttonSlice';
import { useTranslation } from 'react-i18next';


export default function SupplierEvaluation() {

  const [companyData, setCompanyData] = useState([])
  const [attachmentsDealership, setAttachmentsDealership] = useState([])
  const [companyLogo, setCompanyLogo] = useState([])

  const [ndaData, setNdaData] = useState([])
  const [cobcData, setCobcData] = useState([])
  const [bankAccount, setBankAccount] = useState([])
  const [dueDiligence, setDueDiligence] = useState([])
  const [prequalification, setPrequalification] = useState({})

  const userInfo = useSelector(state => state.mainToCard.userInfo)
  const createSup = useSelector(state => state.otherSlice.createSup)
  const reviseSup = useSelector(state => state.otherSlice.reviseSup)
  const reviseSupId = useSelector(state => state.otherSlice.reviseSupId)
  const individualBool = useSelector(state => state.otherSlice.individualBool)

  const [vendorId, setVendorId] = useState(0);

  const companyInformationWithAttachments = {
    ...companyData,
    attachments: attachmentsDealership,
    companyLogo: companyLogo,
    vendorId
  };
  const { dataId } = useParams()

  const { data: userInfoData } = useGetCurrentUserInfoQuery();

  useEffect(() => {
    if (createSup || dataId === '0') {
      setVendorId(0)
    } else if (reviseSup) {
      setVendorId(reviseSupId)
    } else {
      setVendorId(userInfoData?.data?.vendorId)
    }
  }, [userInfo, createSup, reviseSupId, reviseSup, dataId, userInfoData])


  const dispatch = useDispatch();


  const getStepComponent = (step) => {
    switch (step) {
      case 0:
        return (
          <CompanyInformationSup companyData={companyData} setCompanyData={setCompanyData}
            attachmentsDealership={attachmentsDealership} setAttachmentsDealership={setAttachmentsDealership}
            vendorId={vendorId} setVendorId={setVendorId} createSup={createSup} reviseSup={reviseSup}
            companyLogo={companyLogo} setCompanyLogo={setCompanyLogo}
          />
        );

      case 1:
        return (
          <NdaSup checkedItems={ndaData} setCheckedItems={setNdaData}
            companyData={companyInformationWithAttachments}
            vendorId={vendorId} reviseSup={reviseSup}
          />
        );

      case 2:
        return (
          <CobcSup checkedItems={cobcData} setCheckedItems={setCobcData}
            companyData={companyInformationWithAttachments} ndaData={ndaData}
            vendorId={vendorId} reviseSup={reviseSup} />
        );

      case 3:
        return (
          <BankAccountSup tableData={bankAccount} setTableData={setBankAccount}
            companyData={companyInformationWithAttachments} ndaData={ndaData} cobcData={cobcData}
            vendorId={vendorId} reviseSup={reviseSup} country={companyInformationWithAttachments?.country}
          />
        );

      case 4:
        if (individualBool) return null;

        return (
          <DueDiligenceSup tableData={dueDiligence} setTableData={setDueDiligence}
            companyData={companyInformationWithAttachments} ndaData={ndaData} cobcData={cobcData} bankAccount={bankAccount?.filter(item => item.type === 0)}
            vendorId={vendorId} reviseSup={reviseSup} />
        );

      // case 5:
      //   return (
      //     <PrequalificationSup tableData={prequalification} setTableData={setPrequalification}
      //       companyData={companyInformationWithAttachments} ndaData={ndaData} cobcData={cobcData} bankAccount={bankAccount?.filter(item => item.type === 0)} dueDiligence={dueDiligence}
      //       vendorId={vendorId} reviseSup={reviseSup} />
      //   );
      default:
        return null;
    }
  };

  const activeStep = useSelector((state) => state.buttonSlice.activeStep);
  // const saveCheck = useSelector((state) => state.buttonSlice.saveCheck);



  const { t } = useTranslation('supplier')

  const steps = [
    t('company_information'),
    t('nda'),
    t('cobc'),
    t('bank_accounts'),
    !individualBool && t('due_diligence')
  ].filter(Boolean);

  return (
    <>
      <ButtonList />
      <Grid container spacing={2} mt={1}>
        <Grid item sx={{ margin: "0 auto" }} xs={12} sm={11} md={11} lg={10} xl={10}>
          <Card>
            <Stepper
              sx={{ mt: 1, mb: 1 }}
              activeStep={activeStep}
              alternativeLabel
            >
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel
                      onClick={index <= activeStep ? () => dispatch(setStep(index)) : null}  // Tıklanabilirliği kontrol ettik
                      sx={{ cursor: index <= activeStep ? 'pointer' : 'default' }}  // Sadece aktif veya önceki steplerde cursor pointer
                    >
                      {label}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Card>
        </Grid>

        <Grid item sx={{ margin: "0 auto" }} xs={12} sm={11} md={11} lg={10} xl={10}>
          <Card sx={{ p: 2 }}>
            {getStepComponent(activeStep)}
          </Card>
        </Grid>
      </Grid >
    </>

  )
}


